import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_MEASUREMENT_ID = "G-1TM9CJNY59";
const CLARITY_PROJECT_ID = "yd15ut01pe";

function shouldTrack() {
  if (process.env.NODE_ENV !== "production") return false;
  const host = window.location.hostname;
  return host !== "localhost" && host !== "127.0.0.1";
}

function loadGtag() {
  if (window.gtag) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.gtag("js", new Date());
  // Route changes send page_view below. The initial hit is that first event,
  // so the automatic one is turned off to avoid a double count.
  window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });
}

function loadClarity() {
  if (window.clarity) return;

  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", CLARITY_PROJECT_ID);
}

// One event for every homepage action worth counting, so reports group them:
// `action` is open_case_study, copy_email, mailto or download_cv, and `target`
// names what was opened. A no-op wherever analytics did not load.
export function trackAction(action, target) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "portfolio_action", { action, target });
}

// Lives next to DocumentHead so the title is already updated when a page_view
// fires. Only loads on the live site — localhost reloads stay out of the data.
function PageAnalytics() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (!shouldTrack()) return;
    loadGtag();
    loadClarity();
  }, []);

  useEffect(() => {
    if (!shouldTrack() || typeof window.gtag !== "function") return;

    window.gtag("event", "page_view", {
      page_title: document.title,
      page_location: window.location.href,
      page_path: pathname + search,
    });
  }, [pathname, search]);

  return null;
}

export default PageAnalytics;
